import { Modal } from "antd";
import styled, { css } from "styled-components";
import { ReactNode } from "react";

interface MyModalProps {
  open: boolean;
  children1: ReactNode;
  children2?: ReactNode;
  children3?: ReactNode;
  onCancel: () => void;
  onOk: () => void;
  footer: JSX.Element | null;
  isSendToDashboard?: boolean;
  isRedirectPage?: boolean;
}

const ModalComponent: React.FC<MyModalProps> = ({
  open,
  children1,
  children2,
  children3,
  onCancel,
  onOk,
  footer,
  isSendToDashboard,
  isRedirectPage,
}) => {
  return (
    <>
      <StyledModal
        getContainer="#smartsearch-modal"
        closeIcon={false}
        open={open}
        // footer={footer}
        onCancel={onCancel}
        styles={{
          mask: {
            position: "absolute",
            borderRadius: "20px 40px 40px 40px",
          },
        }}
        wrapClassName="absolute-modal-wrap"
        $isRedirectPage={isRedirectPage!}
        isSendToDashboard={isSendToDashboard!}
      >
        <StyledDiv
          $isRedirectPage={isRedirectPage || false}
          $isSendToDashboard={isSendToDashboard!}
        >
          <div>{children1}</div>
          <div className="second-child">{children2}</div>
          <div className="last-child">
            <div>{children3}</div>
            <div className="footer">{footer}</div>
          </div>
        </StyledDiv>
      </StyledModal>
    </>
  );
};

export default ModalComponent;

const StyledModal = styled(Modal)<{
  $isRedirectPage: boolean;
  isSendToDashboard: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-modal-footer {
    display: none;
  }

  .ant-modal-content {
    overflow-x: auto;
    overflow-y: hidden;
    padding: ${(props) =>
      props.$isRedirectPage ? "8px 24px 21px 24px;" : "8px 10px 21px 10px;"};
    // max-width: 90% !important;

    // top: -10px;
    bottom: 5px;
    width: ${(props) => (props.$isRedirectPage ? "400px" : "auto")};
    &::-webkit-scrollbar {
      height: 7px;
    }
    &::-webkit-scrollbar-track {
      background-color: #eff1fd;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #040726;
      border-radius: 20px;
    }
  }
  .ant-modal .ant-modal-footer {
    margin-top: 0px !important;
  }
`;
const StyledDiv = styled.div<{
  $isRedirectPage: boolean;
  $isSendToDashboard: boolean;
}>`
  display: flex;
  flex-direction: row;
  // gap: 50px;
  // min-height: 410px;
  // min-height: 500px;
  margin-top: 13px;
  > div {
    &:first-child {
      // min-width: 235px;
      width: ${(props) => (props.$isSendToDashboard ? "320px" : "100%")};
      margin-right: 5px;
    }
    &:last-child {
      margin-left: auto;
      display: ${(props) => (props.$isRedirectPage ? "none" : "block")};
      min-height: ${(props) => (props.$isSendToDashboard ? "447px" : "auto")};
      padding-right: 10px;
      .footer {
        display: flex;
        justify-content: flex-end;
      }
    }
    &.second-child {
      display: ${(props) => (props.$isRedirectPage ? "none" : "block")};
      // margin-right: 20px;
      margin-right: 15px;
    }
  }
`;
